import type { CSSProperties } from "react";
import type { ThemeConfig } from "../types/domain";

export const cockpitTheme: ThemeConfig = {
  id: "geely-cockpit-v0",
  name: "Geely Cockpit Dark Glass",
  colors: {
    shell: "#08090c",
    surface: "rgba(22, 25, 29, 0.72)",
    surfaceStrong: "rgba(37, 41, 48, 0.9)",
    text: "#f5f7f8",
    textMuted: "#aeb7bb",
    line: "rgba(255, 255, 255, 0.14)",
    accent: "#48d6cf",
    accentAlt: "#a7ef5c",
    success: "#58d879",
    warning: "#ffc857",
    danger: "#ff6f70"
  },
  radii: {
    panel: "8px",
    card: "8px",
    button: "7px"
  },
  effects: {
    blur: "22px",
    glow: "0 0 28px rgba(72, 214, 207, 0.28)",
    shadow: "0 28px 80px rgba(0, 0, 0, 0.42)",
    transitionMs: 340
  },
  typography: {
    fontFamily:
      "\"SF Pro Text\", \"PingFang SC\", \"Microsoft YaHei\", system-ui, -apple-system, BlinkMacSystemFont, \"SF Pro Text Web\", \"PingFang SC Web\", sans-serif",
    numberFamily:
      "\"SF Pro Display\", \"DIN Alternate\", SFMono-Regular, Consolas, \"SF Pro Display Web\", \"SF Pro Text Web\", \"PingFang SC Web\", monospace"
  },
  spacing: {
    appPadding: "20px",
    panelGap: "14px"
  },
  assetPackId: "figma-v0"
};

export function themeToCssVars(theme: ThemeConfig): CSSProperties {
  return {
    "--color-shell": theme.colors.shell,
    "--color-surface": theme.colors.surface,
    "--color-surface-strong": theme.colors.surfaceStrong,
    "--color-text": theme.colors.text,
    "--color-text-muted": theme.colors.textMuted,
    "--color-line": theme.colors.line,
    "--color-accent": theme.colors.accent,
    "--color-accent-alt": theme.colors.accentAlt,
    "--color-success": theme.colors.success,
    "--color-warning": theme.colors.warning,
    "--color-danger": theme.colors.danger,
    "--radius-panel": theme.radii.panel,
    "--radius-card": theme.radii.card,
    "--radius-button": theme.radii.button,
    "--effect-blur": theme.effects.blur,
    "--effect-glow": theme.effects.glow,
    "--effect-shadow": theme.effects.shadow,
    "--transition-ms": `${theme.effects.transitionMs}ms`,
    "--font-ui": theme.typography.fontFamily,
    "--font-number": theme.typography.numberFamily,
    "--app-padding": theme.spacing.appPadding,
    "--panel-gap": theme.spacing.panelGap
  } as CSSProperties;
}
